import { Popconfirm, PopconfirmProps, Typography } from 'antd'
import { FC, PropsWithChildren } from 'react'
import IvyIcon from '../icon'
import './PopConfirm.less'

type PopConfirmProps = PopconfirmProps & {
  title: string
  iconType?: Design.IvyIcon
}

export const PopConfirm: FC<PropsWithChildren<PopConfirmProps>> = ({ iconType, title, children, ...props }) => (
  <Popconfirm
    cancelButtonProps={{
      type: 'ghost',
      size: 'middle',
    }}
    okButtonProps={{
      size: 'middle',
    }}
    icon={iconType ? <IvyIcon size={30} type={iconType} /> : props.icon}
    title={<Typography.Title level={5}>{title}</Typography.Title>}
    {...props}
  >
    {children}
  </Popconfirm>
)
